import { InboxMessage } from '@store/modules/ui/inbox/types';

import { transformMessageBody } from './transformMessageBody';
import { InboxMessageDto } from './dtos/InboxMessageDto';

export function transformInboxMessage(dto: InboxMessageDto): InboxMessage {
    return {
        id: dto.id,
        opened: !!dto.opened,
        clicked: !!dto.clicked,
        createdTime: dto.create_time,
        expirationTime: dto.expiration_time,
        message: transformMessageBody(dto.message),
    };
}
